import { createContext } from 'react';
import { TypePaymentOption } from '../../@types/generated';

type Context = {
  affiliateName?: string;
  campaign?: string;
  color?: string;
  donationProgramId?: string;
  grantmakerName?: TypePaymentOption['fields']['grantmakerName'];
  initiator: string;
  partnerId?: string;
  textColor?: string;
};

const CheckoutContext = createContext<Context>({ initiator: '' });
export default CheckoutContext;
